import axiosPublicClient from "../../../../../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/start-pre-check-session`, data)

    return result.data
}

export default service
